module.exports = __webpack_public_path__ + "img/图片1.2e5b23e1.png";